import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { CreateResponseBase } from '@models/base/createResponseBase.model';
import { UpdateKeyValueRequest } from '@models/base/updateKeyValueRequest.model';
import { CreateTipoSelladoRequest } from '@models/tipo-sellado/createTipoSelladoRequest.model';
import { TipoSelladoDto } from '@models/tipo-sellado/tipoSelladoDto.model';
import { UpdateTipoSelladoRequest } from '@models/tipo-sellado/uptadeTipoSelladoRequest.model';
import { isFalsy } from 'utility-types';

@Injectable({
  providedIn: 'root'
})
export class TiposSelladoService {

  private id!: number;

  set setId(id:number) {
    this.id = id;
  }

  get getId() {
    return this.id;
  }

  constructor(
    private http: HttpClient
  ) { }

  create(createTipoSelladoRequest:CreateTipoSelladoRequest):Observable<CreateResponseBase>
  {
    return  this.http.post<CreateResponseBase>("/api/TipoSellado/Create",createTipoSelladoRequest);
  }

  update(uptadeTipoSelladoRequest:UpdateTipoSelladoRequest):Observable<any>
  {
    return  this.http.put<any>("/api/TipoSellado/Update",uptadeTipoSelladoRequest);
  }

  getAll():Observable<TipoSelladoDto[]>
  {
    return  this.http.get<TipoSelladoDto[]>("/api/TipoSellado/GetAll");
  }

  getById(id:number):Observable<TipoSelladoDto>
  {
    return  this.http.get<TipoSelladoDto>("/api/TipoSellado/GetById?id="+id);
  }

  delete(id: number): Observable<any> {
    if (!isFalsy(id))
      return this.http.delete<any>("/api/TipoSellado/Delete?id=" + id);
    else
      return of(null)
  }
}
